import api from "PFCore/api";
import { Id, PaginatedCollection, QueryParams } from "PFCore/types";
import { KPIEvent } from "PFCore/types/kpi";

export type FetchKPIEventsResponse = PaginatedCollection<KPIEvent[]>;

export type FetchKPIEventsParams = Pick<QueryParams, "page" | "perPage"> & { indicatorId: Id };

export const fetchKPIEvents = (engagementId: Id, params: FetchKPIEventsParams) =>
  api<FetchKPIEventsResponse>({
    url: `engagements/${engagementId}/kpi_events`,
    params
  });
